// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2QNIG","buttons":"Footer_buttons__3Z6WD"};